import Entity from '../entity'

export default class courtInstallation extends Entity<number>{
 name:string="";
 displayOrder:number=0;
 description:string='';
 icon:string=''
}
